import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import IconItem from 'components/common/icon/IconItem';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const StatsItem = ({ stat }) => {
    const {
        icon,
        color,
        title,
        amount,
        caret,
        caretColor,
        target,
        percentage
    } = stat;
    return (
        <>
            <Flex
                justifyContent="center"
                alignItems="center"
                className="mb-3 position-static"
            >
                <IconItem
                    tag="div"
                    icon={icon}
                    bg={`soft-${color}`}
                    color={color}
                    size="sm"
                    iconClass="fs--1"
                    className="me-2 shadow-none"
                />
                <h6 className="mb-0 flex-1">{title}</h6>
            </Flex>
            <Flex
                justifyContent="center"
                alignItems="center">
                <p className={`font-sans-serif lh-1 mb-1 fs-4 pe-2 text-${caretColor}`}> {amount}</p>
                <div className="d-flex flex-column">
                    <FontAwesomeIcon
                        icon={caret}
                        className={`me-1 mb-0 fs-1 text-${caretColor}`}
                    />
                    <p className={`font-sans-serif lh-1 mb-1 fs--1 text-${caretColor}`}>{percentage}%</p>
                </div>
            </Flex>
            <Flex
            >

                <p className="fs--1 mb-0 mt-0 text-nowrap">{target}</p>
            </Flex>

        </>
    );
};

const CrmStats = ({
    mes,
    idUsuario
}) => {
    
    const [stats, setStats] = useState([]);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);

    const ObtenerCRMStats = async (idUsuario, date_) => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerCRMStats/?idUsuario=" + idUsuario + "&date=" + date_, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {
            console.log("==== OBTENER CRM STATS ====");
            console.log(response);
            const data = await response.json();
            console.log("OBTENER CRM STATS", data);
            if (data['table1'][0].iResponseType == 1) {
                //Avisos
                setStats(data['table2']);
                console.log(data['table2'][0])
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerCRMStats(idUsuario, mes)
    }, [idUsuario, mes])

    return (
        <Card>
            <Card.Body>
                <Row>
                    {cargando ?
                        <Skeleton height={50} />
                        :
                        stats.map((stat, index) => (
                            <Col
                                xxl={2}
                                xl={4}
                                lg={4}
                                md={4}
                                sm={6}
                                key={stat.id}
                                className={classNames({
                                    'border-bottom border-lg-0 border-lg-end':
                                        index !== stats.length - 1,
                                    'pb-3 pb-lg-0': index === 0,
                                    'py-3 py-lg-0': index === 1,
                                    'pt-3 pt-lg-0': index === 2
                                })}
                            >
                                <StatsItem stat={stat} />
                            </Col>
                        ))

                    }
                </Row>
            </Card.Body>
        </Card>
    );
};

StatsItem.propTypes = {
    stat: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        percentage: PropTypes.number.isRequired,
        caret: PropTypes.string.isRequired,
        caretColor: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    })
};

CrmStats.propTypes = {
    idUsuario: PropTypes.number,
    mes: PropTypes.instanceOf(Date)
};

export default CrmStats;
